import React from 'react';
import { Link } from 'react-router-dom';
import CountUp from 'react-countup';
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

import bgImg1 from "../../assets/images/backgrounds/slider-1-1.jpg";
import bgImg3 from "../../assets/images/backgrounds/slider-1-2.jpg";
import bgImg4 from "../../assets/images/backgrounds/slider-1-3.jpg";
import bgImg2 from "../../assets/images/shapes/main-slider-shape-2.png";
import MainSliderImg1 from "../../assets/images/resources/security-consulting-.png";
import MainSliderImg12 from "../../assets/images/resources/security-consulting1-.png";
import MainSliderImg2 from "../../assets/images/resources/audit-and-compilance.png";
import MainSliderImg21 from "../../assets/images/resources/audit-and-compilance1.png";
import MainSliderImg3 from "../../assets/images/resources/managed-it-service.png";
import MainSliderImg31 from "../../assets/images/resources/managed-it-service1.png";
import MainSliderImg4 from "../../assets/images/resources/cloud-computing.png";
import MainSliderImg41 from "../../assets/images/resources/cloud-computing1.png";
import MainSliderImg5 from "../../assets/images/resources/design-implementation.png";
import MainSliderImg51 from "../../assets/images/resources/design-implementation1.png";
import SliderContentShape1 from "../../assets/images/shapes/main-slider-content-shape-1.png";

const swiperOptions = {
  modules: [Autoplay, Pagination, Navigation],
  slidesPerView: 1,
  loop: true,
  effect: 'fade',
  pagination: {
    el: '#main-slider-pagination',
    type: 'bullets',
    clickable: true
  },
  navigation: {
    nextEl: '#main-slider__swiper-button-next',
    prevEl: '#main-slider__swiper-button-prev'
  },
  autoplay: {
    delay: 8000
  }
}

export default function Banner() {
  return (
    <section className="main-slider">
      <Swiper {...swiperOptions} className="swiper-container thm-swiper__slider">
        <SwiperSlide className="swiper-slide">
          <div
            className="main-slider__bg"
            // style={{ backgroundImage: `url(${bgImg1})` }}
          />
          <div className="main-slider__shape-1" />
          <div
            className="main-slider__shape-2"
            // style={{ backgroundImage: `url(${bgImg2})` }}
          />
          <div className="main-slider__img desktop-view">
            <img src={MainSliderImg1} alt="" />
          </div>
          <div className="main-slider__img mobile-view">
            <img src={MainSliderImg12} alt="" />
          </div>
          <div className="container">
            <div className="main-slider__content">
              <div className="main-slider__content-shape-1">
                <img src={SliderContentShape1} alt="" />
              </div>
              <h2 className="main-slider__title">
              Security&nbsp;<span><br /> Consulting</span> 
              </h2>
              <h4 className="main-slider__subtitle">
              Fortify Your Business with Expert<br></br>Security Consulting
              </h4>   
              <ul className="list-unstyled main-slider__counter">
                <li>
                  <div className="main-slider__counter-single">
                    <div className="main-slider__count count-box">
                      <h3 className="count-text">
                        {/* <CountUp end={30} duration={1.5} /> */}
                      </h3>
                      {/* <span>k</span> */}
                      {/* <span>+</span> */}
                    </div>
                    {/* <p className="main-slider__count-text">Project Completed</p> */}
                  </div>
                </li>
                <li>
                  <div className="main-slider__counter-single">
                    <div className="main-slider__count count-box">
                      <h3 className="count-text">
                        {/* <CountUp end={2} duration={1.5} /> */}
                      </h3>
                      {/* <span>k</span> */}
                      {/* <span>+</span> */}
                    </div>
                    {/* <p className="main-slider__count-text">Our Team Member</p> */}
                  </div>
                </li>
              </ul>
              <div className="main-slider__btn-and-call-box">
                <div className="main-slider__btn-box">
                  <Link to="/security-consulting" className="thm-btn-two main-slider__btn">
                    get service <span className="icon-dubble-arrow-right" />
                  </Link>
                </div>
                {/* <div className="main-slider__call">
                  <div className="main-slider__call-icon">
                    <span className="icon-call" />
                  </div>
                  <div className="main-slider__call-number">
                    <p>Need help?</p>
                    <h5>
                      <a href="tel:8085550111">+91 80969 62555</a>
                    </h5>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <div
            className="main-slider__bg"
            // style={{ backgroundImage: `url(${bgImg3})` }}
          />
          <div className="main-slider__shape-1" />
          <div
            className="main-slider__shape-2"
            // style={{ backgroundImage: `url(${bgImg2})` }}
          />
          <div className="main-slider__img desktop-view">
            <img src={MainSliderImg2} alt=""/>
          </div>
          <div className="main-slider__img mobile-view">
            <img src={MainSliderImg21} alt="" />
          </div>
          <div className="container">
            <div className="main-slider__content">
              <div className="main-slider__content-shape-1">
                <img src={SliderContentShape1} alt="" />
              </div>
              <h2 className="main-slider__title">
                Audit&nbsp;& <br /><span>Compliance</span>
              </h2>
              <h4 className="main-slider__subtitle">
              Ensure Compliance And Protect<br></br> Your Assets with Our Audit Services
              </h4> 
              <ul className="list-unstyled main-slider__counter">
                <li>
                  <div className="main-slider__counter-single">
                    <div className="main-slider__count count-box">
                      <h3 className="count-text">
                        {/* <CountUp end={30} duration={1.5} /> */}
                      </h3>
                      {/* <span>k</span> */}
                      {/* <span>+</span> */}
                    </div>
                    {/* <p className="main-slider__count-text">Project Completed</p> */}
                  </div>
                </li>
                <li>
                  <div className="main-slider__counter-single">
                    <div className="main-slider__count count-box">
                      <h3 className="count-text">
                        {/* <CountUp end={2} duration={1.5} /> */}
                      </h3>
                      {/* <span>k</span> */}
                      {/* <span>+</span> */}
                    </div>
                    {/* <p className="main-slider__count-text">Our Team Member</p> */}
                  </div>
                </li>
              </ul>
              <div className="main-slider__btn-and-call-box">
                <div className="main-slider__btn-box">
                  <Link to="/audit-&-compliance" className="thm-btn-two main-slider__btn">
                    get service <span className="icon-dubble-arrow-right" />
                  </Link>
                </div>
                {/* <div className="main-slider__call">
                  <div className="main-slider__call-icon">
                    <span className="icon-call" />
                  </div>
                  <div className="main-slider__call-number">
                    <p>Need help?</p>
                    <h5>
                      <a href="tel:8085550111">+91 80969 62555</a>
                    </h5>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <div
            className="main-slider__bg"
            // style={{ backgroundImage: `url(${bgImg4})` }}
          />
          <div className="main-slider__shape-1" />
          <div
            className="main-slider__shape-2"
            // style={{ backgroundImage: `url(${bgImg2})` }}
          />
          <div className="main-slider__img desktop-view">
            <img src={MainSliderImg3} alt="" />
          </div>
          <div className="main-slider__img mobile-view">
            <img src={MainSliderImg31} alt="" />
          </div>
          <div className="container">
            <div className="main-slider__content">
              <div className="main-slider__content-shape-1">
                <img src={SliderContentShape1} alt="" />
              </div>
              <h2 className="main-slider__title">
                Managed&nbsp;<br /><span>IT Services</span>
              </h2>
              <h4 className="main-slider__subtitle">
              Ensure Compliance And Protect Your Assets<br /> with Managed Services
              </h4> 
              <ul className="list-unstyled main-slider__counter">
                <li>
                  <div className="main-slider__counter-single">
                    <div className="main-slider__count count-box">
                      <h3 className="count-text">
                        {/* <CountUp end={30} duration={1.5} /> */}
                      </h3>
                      {/* <span>k</span> */}
                      {/* <span>+</span> */}
                    </div>
                    {/* <p className="main-slider__count-text">Project Completed</p> */}
                  </div>
                </li>
                <li>
                  <div className="main-slider__counter-single">
                    <div className="main-slider__count count-box">
                      <h3 className="count-text">
                        {/* <CountUp end={2} duration={1.5} /> */}
                      </h3>
                      {/* <span>k</span> */}
                      {/* <span>+</span> */}
                    </div>
                    {/* <p className="main-slider__count-text">Our Team Member</p> */}
                  </div>
                </li>
              </ul>
              <div className="main-slider__btn-and-call-box">
                <div className="main-slider__btn-box">
                  <Link to="/managed-it-services" className="thm-btn-two main-slider__btn">
                    get service <span className="icon-dubble-arrow-right" />
                  </Link>
                </div>
                {/* <div className="main-slider__call">
                  <div className="main-slider__call-icon">
                    <span className="icon-call" />
                  </div>
                  <div className="main-slider__call-number">
                    <p>Need help?</p>
                    <h5>
                      <a href="tel:8085550111">+91 80969 62555</a>
                    </h5>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <div
            className="main-slider__bg"
            // style={{ backgroundImage: `url(${bgImg3})` }}
          />
          <div className="main-slider__shape-1" />
          <div
            className="main-slider__shape-2"
            // style={{ backgroundImage: `url(${bgImg2})` }}
          />
        <div className="main-slider__img desktop-view">
            <img src={MainSliderImg4} alt="" />
          </div>
          <div className="main-slider__img mobile-view">
            <img src={MainSliderImg41} alt="" />
          </div>
          <div className="container">
            <div className="main-slider__content">
              <div className="main-slider__content-shape-1">
                <img src={SliderContentShape1} alt="" />
              </div>
              <h2 className="main-slider__title">
              Cloud&nbsp;<br /><span>Security </span>
              </h2>
              <h4 className="main-slider__subtitle">
              Ensure Compliance And Protect Your Assets with<br/> Cloud Security Solutions
              </h4> 
              <ul className="list-unstyled main-slider__counter">
                <li>
                  <div className="main-slider__counter-single">
                    <div className="main-slider__count count-box">
                      <h3 className="count-text">
                        {/* <CountUp end={30} duration={1.5} /> */}
                      </h3>
                      {/* <span>k</span> */}
                      {/* <span>+</span> */}
                    </div>
                    {/* <p className="main-slider__count-text">Project Completed</p> */}
                  </div>
                </li>
                <li>
                  <div className="main-slider__counter-single">
                    <div className="main-slider__count count-box">
                      <h3 className="count-text">
                        {/* <CountUp end={2} duration={1.5} /> */}
                      </h3>
                      {/* <span>k</span> */}
                      {/* <span>+</span> */}
                    </div>
                    {/* <p className="main-slider__count-text">Our Team Member</p> */}
                  </div>
                </li>
              </ul>
              <div className="main-slider__btn-and-call-box">
                <div className="main-slider__btn-box">
                  <Link to="/cloud-security" className="thm-btn-two main-slider__btn">
                    get service <span className="icon-dubble-arrow-right" />
                  </Link>
                </div>
                {/* <div className="main-slider__call">
                  <div className="main-slider__call-icon">
                    <span className="icon-call" />
                  </div>
                  <div className="main-slider__call-number">
                    <p>Need help?</p>
                    <h5>
                      <a href="tel:8085550111">+91 80969 62555</a>
                    </h5>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </SwiperSlide>
        <SwiperSlide className="swiper-slide">
          <div
            className="main-slider__bg"
            // style={{ backgroundImage: `url(${bgImg3})` }}
          />
          <div className="main-slider__shape-1" />
          <div
            className="main-slider__shape-2"
            // style={{ backgroundImage: `url(${bgImg2})` }}
          />
          <div className="main-slider__img desktop-view">
            <img src={MainSliderImg5} alt="" />
          </div>
          <div className="main-slider__img mobile-view">
            <img src={MainSliderImg51} alt="" />
          </div>
          <div className="container">
            <div className="main-slider__content">
              <div className="main-slider__content-shape-1">
                <img src={SliderContentShape1} alt="" />
              </div>
              <h2 className="main-slider__title">
              Design&nbsp;& <span> <br/>Implementation</span>
              </h2>
              <h4 className="main-slider__subtitle">
              Transform Your Vision Into Reality with <br/>Our Design and Implementation
              </h4> 
              <ul className="list-unstyled main-slider__counter">
                <li>
                  <div className="main-slider__counter-single">
                    <div className="main-slider__count count-box">
                      <h3 className="count-text">
                        {/* <CountUp end={30} duration={1.5} /> */}
                      </h3>
                      {/* <span>k</span> */}
                      {/* <span>+</span> */}
                    </div>
                    {/* <p className="main-slider__count-text">Project Completed</p> */}
                  </div>
                </li>
                <li>
                  <div className="main-slider__counter-single">
                    <div className="main-slider__count count-box">
                      <h3 className="count-text">
                        {/* <CountUp end={2} duration={1.5} /> */}
                      </h3>
                      {/* <span>k</span> */}
                      {/* <span>+</span> */}
                    </div>
                    {/* <p className="main-slider__count-text">Our Team Member</p> */}
                  </div>
                </li>
              </ul>
              <div className="main-slider__btn-and-call-box">
                <div className="main-slider__btn-box">
                  <Link to="/design-&-implementation" className="thm-btn-two main-slider__btn">
                    get service <span className="icon-dubble-arrow-right" />
                  </Link>
                </div>
                {/* <div className="main-slider__call">
                  <div className="main-slider__call-icon">
                    <span className="icon-call" />
                  </div>
                  <div className="main-slider__call-number">
                    <p>Need help?</p>
                    <h5>
                      <a href="tel:8085550111">+91 80969 62555</a>
                    </h5>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </SwiperSlide>
        {/* Other Swiper Slides */}

      </Swiper>
      <div id="main-slider-pagination" className="swiper-pagination" />
    </section>
  );
}
